import React, { useCallback } from 'react'
import { useParams } from 'react-router'
import { isMobile, MobileView, BrowserView } from 'react-device-detect'
import styled from 'styled-components'
import { VERIFICATION_STATUS } from '../../constants'
import { useQueryParamLang, useLanguage } from '../../hooks'
import Text from '../../components/common/Text'
import Icon from '../../components/common/Icon'
import ImageBackground from '../../components/common/ImageBackground'
import Block from '../../components/common/Block'
import Button from '../../components/common/Button'
import Spacer from '../../components/common/Spacer'
import Timer from '../../components/common/Timer'

const {
    REACT_APP_FIREBASE_PROJECT_ID,
} = process.env

const MainContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100vh
`

const AccountWidget = () => {

    const { status = VERIFICATION_STATUS.failed } = useParams()
    const { lang } = useQueryParamLang()
    const { t } = useLanguage(lang)

    const redirectToLink = useCallback(() => {
        // Deep link URL for existing users with app already installed on their device
        window.location.href = `${REACT_APP_FIREBASE_PROJECT_ID.replace('prod', '')}://accept`
    }, [])

    return (
        <ImageBackground
            imageName="blurredLeafs@2x.jpg"
            cover
        >
            <MainContainer>
                <Block
                    pv="Z"
                    ph="XXL"
                    style={{
                        maxWidth: '500px',
                        height: 'calc(100vh - 20%)',
                        justifyContent: isMobile ? 'space-between' : 'flex-start',
                    }}
                >

                    <Spacer size="G" />

                    <Icon
                        width="30%"
                        iconName={`${status === VERIFICATION_STATUS.success ? 'checkmark' : 'bolt'}@2x.png`}
                        alignSelf="center"
                    />

                    <Spacer size="G" />

                    <div>
                        <Text
                            tag="h1"
                            color="white"
                            size="XXXL"
                            semibold
                        >
                            {t(`accountWidget.${status}.title`)}
                        </Text>

                        <Spacer size="XXL" />

                        {status === VERIFICATION_STATUS.failed && (
                            <>
                                <Text
                                    tag="p"
                                    color="white"
                                    semibold
                                >
                                    {t('accountWidget.contactUs.title')}
                                </Text>

                                <Spacer size="L" />

                                <Text
                                    tag="p"
                                    color="white"
                                    size="XL"
                                    semibold
                                >
                                    {t('accountWidget.supportEmail.title')}
                                </Text>
                            </>
                        )}
                    </div>

                    <Spacer size="G" />

                    {status !== VERIFICATION_STATUS.failed && (
                        <>
                            <MobileView>
                                <Text
                                    center
                                    tag="p"
                                    color="white"
                                    semibold
                                >
                                    {t('accountWidget.redirect.title')}
                                </Text>
                                <Spacer size="S" />
                                <Timer
                                    center
                                    size="G"
                                    color="white"
                                    initialValue={3}
                                    onEnd={redirectToLink}
                                />
                                <Spacer size="S" />
                                <Text
                                    color="grey3"
                                    center
                                    size="S"
                                >
                                    {t('accountWidget.manualRedirect.title')}
                                </Text>
                                <Spacer />
                                <Button
                                    onClick={redirectToLink}
                                    title={t('accountWidget.redirectButton.title')}
                                />
                            </MobileView>
                            <BrowserView>
                                <Text
                                    tag="p"
                                    color="white"
                                    semibold
                                >
                                    {t('accountWidget.redirectNow.title')}
                                </Text>
                            </BrowserView>
                        </>
                    )}
                </Block>
            </MainContainer>
        </ImageBackground>
    )
}

export default AccountWidget
